import React, { useEffect, useState } from "react";
import "./carExtractor.css";

interface Props {
  favorites: number[];
  setFavorites: React.Dispatch<React.SetStateAction<number[]>>;
}

const CarExtractor: React.FC<Props> = ({ favorites, setFavorites }) => {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    const carsParam = url.searchParams.get("cars");

    if (carsParam) {
      const parsed = carsParam
        .split(",")
        .map((id) => parseInt(id.trim()))
        .filter((id) => !isNaN(id));

      setFavorites(parsed);
      setShowNotification(true);
      localStorage.setItem("favorites", JSON.stringify(parsed));

      // Remove 'cars' param from URL without reloading
      url.searchParams.delete("cars");
      window.history.replaceState({}, "", url.toString());
    }
  }, [setFavorites, setShowNotification]);

  if(showNotification){
    setTimeout(() => setShowNotification(false), 3000);
  }

  return (
    <>
      {showNotification && (
        <div className="notification is-info custom-notification">
          <strong>Extracted Car IDs:</strong>
          <br />
          {favorites.length > 0
            ? favorites.join(", ")
            : "No car IDs found in URL."}
        </div>
      )}
    </>
  );
};

export default CarExtractor;
